var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rule-item',{attrs:{"isDelete":false,"ruleForm":_vm.ruleForm,"propertyDatas":_vm.propertyDatas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }